module.exports = __webpack_public_path__ + "img/kkb_flame.749e4db7.jpg";